/** Split pipe-delimited skill strings from i18n bundles. */
export function splitPreviewSkills(value: string): string[] {
  return value
    .split('|')
    .map((skill) => skill.trim())
    .filter(Boolean);
}
